import { ReactComponent as IconCart } from 'asserts/icons/ic_cart_lined_main.svg';
import { ReactComponent as IconDownload } from 'asserts/icons/ic_download_lined_main.svg';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const FloatingButton = () => {
  const navigate = useNavigate();
  const handleClickMovePage = () => {
    navigate('/download');
  };

  const onClickPurchase = () => {
    window.open('https://smartstore.naver.com/exbody1');
  };

  return (
    <Wrapper>
      <BtnBack>
        <Btn onClick={handleClickMovePage}>
          <IconDownload />
          <p className="text">
            프로그램
            <br />
            다운로드
          </p>
        </Btn>
      </BtnBack>
      <BtnBack>
        <Btn onClick={onClickPurchase}>
          <IconCart />
          <p className="text">
            장비
            <br />
            구매하기
          </p>
        </Btn>
      </BtnBack>
    </Wrapper>
  );
};

export default FloatingButton;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BtnBack = styled.div`
  border-radius: 50%;
  background: ${color.gradientType1};
  width: 96px;
  height: 96px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
`;

const Btn = styled.div`
  margin: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 93px;
  height: 93px;
  background: ${color.gradientType1};
  border-radius: 50%;
  cursor: pointer;

  p.text {
    color: ${color.white};
    text-align: center;
    text-shadow: 0px 2px 4px ${color.opacityBlack02};
    ${font.caption2_medium};
    transition: all 0.2s;
  }
  svg {
    width: 32px;
    height: 32px;
    fill: ${color.white};
    transition: all 0.2s;
  }
  &:hover {
    background: ${color.white};
    p.text {
      color: ${color.gray800};
      text-shadow: none;
    }
    svg {
      fill: ${color.gray800};
    }
  }
`;
